<template>
  <div class="didacticiel">

    <div class="grid-container content-page">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-6 medium-offset-3 cell center">
          <title-page attrpage="Globulo Quest" baseline="">1ère étape :</title-page>
        </div>
        <div class="small-12 medium-6 medium-offset-3 cell ">


          <div class="box-mascotte">
            <div class="bubble bottom txtleft">
              <carousel :perPage="1" paginationActiveColor="#de2128" navigationEnabled="true" paginationColor="#ccc" :paginationSize="15">
                <slide>
                  <p>Bienvenue dans l'aventure Globulo Quest, la toute première étape est de créer un compte pour votre enfant qui lui permettra de commencer à utiliser ce programme d’accompagnement.</p>
                  <bouton href="signupChild">Créer un compte pour mon enfant</bouton>
                </slide>
              </carousel>
            </div>
            <img src="@/assets/images/mascotte/mascotte-red.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    components: { TitlePage, Bouton, Carousel, Slide }
  }

</script>
